import styled from 'styled-components';

export const Container = styled.div`
  h5 {
    color: ${(props) => props.theme.$gray_introducao};
    font-weigh: 500;
  }

  span {
    color: ${(props) => props.theme.$gray_introducao};
    font-weigh: 400;
`;
